import { getSnapshot, subscribe } from "./reachability.ts";

/**
 * Runs a route loader's fetches without waiting on them once the app goes
 * offline. Under `networkMode: "offlineFirst"` (`lib/queryDefaults.ts`) a fetch
 * paused by the flip never settles, so a loader that awaits it would hold the
 * route on its pending component until the connection returns. Resolving on the
 * flip lets the component render from the persisted detail or the prepared row.
 */
export async function loadUnlessOffline(
	load: () => Promise<unknown>,
): Promise<void> {
	if (!getSnapshot()) return;

	let unsubscribe = () => {};
	const wentOffline = new Promise<void>((resolve) => {
		unsubscribe = subscribe(() => {
			if (!getSnapshot()) resolve();
		});
	});
	try {
		await Promise.race([load(), wentOffline]);
	} finally {
		unsubscribe();
	}
}
